import React  , { useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { Grid, TextField } from '@mui/material';
import { LocalizationProvider, MobileDatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'



const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export default function ModalProcedure(props) {
    const [bodyModal, setBodyModal] = useState({ observations: '', quantity: '', requestDate: new Date(), description: '', id:''})
    const handleChangeModal = e => {
        setBodyModal({
          ...bodyModal,
          [e.target.name]: e.target.value
      })
    }

    const onSubmit = (props) => {
    
        props.addProcedure(bodyModal);
      
	 }

     const handleChangeDate = (newValue) => {
        bodyModal.requestDate = newValue;
        setBodyModal(bodyModal);
    };

  return (
    <div>
      <Modal
        open={true}
        onClose={props.handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
        <form>
                <Grid container spacing={2} > 
                    
                    <Grid item xs={12}>
                        
                        <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Descripcion</Typography>
                        <TextField
                            id='description'
                            name='description'
                            value={bodyModal.description}
                            onChange={handleChangeModal}
                            variant='outlined'
                            aria-label="minimum height"
                           />
                   
                    </Grid>
                    
                    <Grid item xs={12}>
                        
                        <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Cantidad</Typography>
                        <TextField
                            id='quantity'
                            name='quantity'
                            value={bodyModal.quantity}
                            onChange={handleChangeModal}
                            variant='outlined'
                            aria-label="minimum height"
                           />
                   
                    </Grid>

                    <Grid item xs={12} >
                    <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Fecha de Solicitud</Typography>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <MobileDatePicker
                                id='requestDate'
                                name='requestDate'
                                label="Date mobile"
                                inputFormat="MM/dd/yyyy"
                                value={bodyModal.requestDate}
                                onChange={handleChangeDate}
                                renderInput={(params) => <TextField {...params} />}
                            />
                        </LocalizationProvider>
                    </Grid>

                    

                    <Grid item xs={12}>
                    <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Observaciones</Typography>
                        <TextField
                            id='observations'
                            name='observations'
                            value={bodyModal.observations}
                            onChange={handleChangeModal}
                            variant='outlined'
                            aria-label="minimum height"
                           />
                   
                    </Grid>

                    <Grid item xs={12} >
                
                      <Button 
                     // type="submit" 
                      variant="contained" 
                      color="primary" 
                      display="inline" 
                      //onClick={() => buttonSave(props)}
                      onClick={() => onSubmit(props)}
                      >
                          Guardar
                      </Button>
                  </Grid>

                    </Grid>
                 </form>
        </Box>
      </Modal>
    </div>
  );
}